// Testimonial Carousel Module
(function() {
  'use strict';

  class TestimonialCarousel {
    constructor(container) {
      this.container = container;
      this.currentIndex = 0;
      this.interval = null;
      this.init();
    }

    init() {
      this.setupEventListeners();
      this.updateCarousel();
      this.startAutoplay();
    }

    setupEventListeners() {
      const prevBtn = this.container.querySelector('[data-testimonial-prev]');
      const nextBtn = this.container.querySelector('[data-testimonial-next]');
      const indicators = this.container.querySelectorAll('[data-indicator]');

      if (prevBtn) {
        prevBtn.addEventListener('click', () => this.previousTestimonial());
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => this.nextTestimonial());
      }

      indicators.forEach((indicator, index) => {
        indicator.addEventListener('click', () => {
          this.currentIndex = index;
          this.updateCarousel();
          this.resetAutoplay();
        });
      });

      // Pause on hover
      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => this.startAutoplay());
    }

    updateCarousel() {
      const cards = this.container.querySelectorAll('[data-testimonial-card]');
      const indicators = this.container.querySelectorAll('[data-indicator]');
      const totalCards = cards.length;

      if (totalCards === 0) return;

      // Calculate prev, current, and next indices (with circular wrapping)
      const prevIndex = (this.currentIndex - 1 + totalCards) % totalCards;
      const nextIndex = (this.currentIndex + 1) % totalCards;

      cards.forEach((card, index) => {
        // Remove all position classes
        card.classList.remove('prev', 'active', 'next');

        // Add appropriate class based on position
        if (index === prevIndex) {
          card.classList.add('prev');
        } else if (index === this.currentIndex) {
          card.classList.add('active');
        } else if (index === nextIndex) {
          card.classList.add('next');
        }
      });

      indicators.forEach((indicator, index) => {
        if (index === this.currentIndex) {
          indicator.classList.add('active');
        } else {
          indicator.classList.remove('active');
        }
      });
    }

    nextTestimonial() {
      const cards = this.container.querySelectorAll('[data-testimonial-card]');
      this.currentIndex = (this.currentIndex + 1) % cards.length;
      this.updateCarousel();
      this.resetAutoplay();
    }

    previousTestimonial() {
      const cards = this.container.querySelectorAll('[data-testimonial-card]');
      this.currentIndex = (this.currentIndex - 1 + cards.length) % cards.length;
      this.updateCarousel();
      this.resetAutoplay();
    }

    startAutoplay() {
      this.interval = setInterval(() => this.nextTestimonial(), 8000);
    }

    stopAutoplay() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  // Initialize carousels when DOM is ready
  function initCarousels() {
    const carousels = document.querySelectorAll('[data-testimonial-carousel]');
    carousels.forEach(carousel => new TestimonialCarousel(carousel));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  // Re-initialize on theme editor section load
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initCarousels);
  }
})();
